import React from "react";

import "./FilterMenu.css";

const FilterMenu = ({filter, updateFilter}) => {
  
  const tagsList = Object.keys(filter);

  return (
    <ul className="filtermenu-container">
      {
        tagsList.map((f) => {
          return (
            <li key={`${f}`} className="filtermenu-item">
              <input 
                type="checkbox" 
                id={`${f}`} 
                onChange={() => updateFilter(f)} 
                checked={filter[f].active}
              />
              <label 
                htmlFor={`${f}`}
                style={{
                  backgroundColor: filter[f].bkgColor || "#FFF",
                  color: filter[f].textColor || "#000",
                }}
              >
                {f}
              </label>
            </li>
            )
          })
      }
    </ul>
  )
}

export default FilterMenu